import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { MenuItem, Button, Classes, Dialog } from '@blueprintjs/core'

import { MultiSelect } from '@blueprintjs/select'
import { getAction, updateAction } from 'src/store/modules/runbooks/actions'
import { toggleControl } from 'src/store/modules/ui/runbook/controls'

class ParentsDialog extends React.Component {
    state = {
        selectedItems:
            (this.props.action && [...this.props.action.parents]) || [],
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isEditingParents && this.props.isEditingParents) {
            this.setState({
                selectedItems: [...this.props.action.parents],
            })
        }
    }

    deselectItem = (index) =>
        this.setState({
            selectedItems: this.state.selectedItems.filter(
                (id, i) => i !== index
            ),
        })

    renderTag = (item) => this.props.runbookActions.byId[item].name

    handleFilter = (query, items) =>
        items
            .filter(
                (item) =>
                    this.props.runbookActions.byId[item].name
                        .toLowerCase()
                        .indexOf(query.toLowerCase()) >= 0 ||
                    item.toString().indexOf(query) > -1
            )
            .slice(0, 10)
    handleRemove = (item, index) => this.deselectItem(index)
    itemRenderer = (item, { handleClick, modifiers }) => {
        const { byId } = this.props.runbookActions
        const orderId =
            this.props.runbookActions.uids.indexOf(byId[item].uid) + 1
        return (
            <MenuItem
                active={modifiers.active}
                key={item}
                onClick={handleClick}
                text={`${orderId}/${byId[item].uid}. ${byId[item].name}`}
            />
        )
    }

    render() {
        const {
            runbookId,
            isEditingParents,
            action,
            runbookActions,
            actions: { toggleControl },
        } = this.props
        if (!isEditingParents) return null

        return (
            <Dialog
                onClose={() => toggleControl('isEditingParents')}
                title={action.name}
                isOpen={true}
                canOutsideClickClose={false}
            >
                <div className={Classes.DIALOG_BODY}>
                    <MultiSelect
                        items={runbookActions.uids.filter(
                            (id, i, arr) =>
                                id !== action.uid &&
                                !this.state.selectedItems.includes(id) &&
                                !action.children.includes(id) //&& !isDevice(runbookActions.byId[id]),
                        )}
                        itemRenderer={this.itemRenderer}
                        onItemSelect={(i) => {
                            // update Action parents here
                            this.setState({
                                selectedItems: [...this.state.selectedItems, i],
                            })
                        }}
                        selectedItems={this.state.selectedItems}
                        noResults={
                            <MenuItem disabled={true} text="No results." />
                        }
                        itemListPredicate={this.handleFilter}
                        tagRenderer={this.renderTag}
                        tagInputProps={{ onRemove: this.handleRemove }}
                        popoverProps={{
                            className: 'multiselect_wrapper',
                            minimal: true,
                        }}
                    />
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            intent="primary"
                            large
                            onClick={() => {
                                this.props.actions.updateAction(
                                    runbookId,
                                    action.uid,
                                    {
                                        parents: [...this.state.selectedItems],
                                    }
                                )
                                toggleControl('isEditingParents')
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={() => toggleControl('isEditingParents')}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

const mapParentsDialogState = (state) => ({
    isEditingParents: state.ui.runbook.controls.isEditingParents,
    runbookId: state.ui.runbook.activeRunbook,
    action: getAction(
        state,
        state.ui.runbook.activeRunbook,
        state.ui.runbook.controls.singleOpenAction
    ),
    runbookActions: state.runbooks.byId[state.ui.runbook.activeRunbook].actions,
})

const mapParentsDialogDispatch = (dispatch, ownProps) => ({
    dispatch,
    actions: bindActionCreators(
        {
            updateAction,
            toggleControl,
        },
        dispatch
    ),
})

export default connect(
    mapParentsDialogState,
    mapParentsDialogDispatch
)(ParentsDialog)
